let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6h0Nb")).then(() => parcelRequire('5c5SM'));